<template>
    <div class="mod-user">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
            <el-form-item>
                <el-input v-model="dataForm.searchKey" placeholder="关键字" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" @click="getDataList()">查询</el-button>
            </el-form-item>
<!--            <el-form-item style="float: right">-->
<!--                <el-button size="small" @click="importFieldListHandle()">导入数据集字段</el-button>-->
<!--            </el-form-item>-->
<!--            <el-form-item style="float: right">-->
<!--              <el-button size="small" @click="addOrUpdateHandle('',dataForm.ruleId, '')">添加字段</el-button>-->
<!--            </el-form-item>-->
<!--            <el-form-item style="float: right">-->
<!--                <el-button type="primary" size="small" @click="batchSetting(dataForm.ruleId)">批量设置</el-button>-->
<!--            </el-form-item>-->
          <el-form-item style="float: right">
            <el-button type="primary" size="small" @click="deleteCache(dataForm.ruleId)">清理缓存</el-button>
            <el-button type="primary" size="small" @click="initColumnData(dataForm.ruleId)">表单初始化</el-button>
          </el-form-item>
        </el-form>
        <el-table
                :data="dataList"
                row-key="id"
                border
                stripe
                ref="dataTable"
                v-loading="dataListLoading"
                @selection-change="selectionChangeHandle"
                style="width: 100%;">
            <el-table-column type="selection" align="center" fixed width="55"></el-table-column>
            <el-table-column fixed type="index" header-align="center" align="center" label="序号" width="60" :index="getRowsIndex"></el-table-column>
            <el-table-column
                    fixed
                    header-align="center"
                    align="center"
                    width="100"
                    label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row.id,scope.row.tableId, scope.row.columnName)">编辑</el-button>
                    <el-button type="text" size="small" @click="deleteHandler(scope.row.id,scope.row.tableId)">删除</el-button>
                </template>
            </el-table-column>
            <el-table-column fixed prop="displayName" header-align="center" align="left" min-width="200" label="字段名称"></el-table-column>
            <el-table-column prop="itemCode" header-align="center" align="left" min-width="200" label="字段编码"></el-table-column>
            <el-table-column prop="columnName" header-align="center" align="left" min-width="200" label="字段名称[数据库]"></el-table-column>
            <el-table-column prop="dataTypeDesc" header-align="center" align="left" width="95" label="数据类型"></el-table-column>
            <el-table-column prop="requiredDesc" header-align="center" align="left" width="70" label="必填">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.required === true" size="small">必填</el-tag>
                    <el-tag v-if="scope.row.required === false" size="small" type="warning">非必填</el-tag>
                    <span v-else></span>
                </template>
            </el-table-column>
            <el-table-column prop="isUnionIndex" header-align="center" align="center" width="60" label="查重字段">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.isUnionIndex === true" size="small">是</el-tag>
                    <el-tag v-else size="small" type="warning">否</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="defaultValue" header-align="center" align="left" width="80" label="默认值"></el-table-column>

        </el-table>
        <el-pagination
                @size-change="sizeChangeHandle"
                @current-change="currentChangeHandle"
                :current-page="pageIndex"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                :total="totalCount"
                layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
        <!-- 弹窗, 新增 / 修改 -->
        <import-field-list v-if="importFieldListVisible" ref="importFieldList" @refreshDataList="getDataList"/>
        <item-list-batchsetting v-if="itemListBatchsettingVisible" ref="batchsettingDialog"
                                @refreshDataList="getDataList"/>
    </div>
</template>
<script>
    import AddOrUpdate from './table_config_column_edit'
    import ImportFieldList from './table_config_column_import'
    import ItemListBatchsetting from './table_config_column_batchsetting'

    export default {
    props: {
      dataSetId: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        dataForm: {
          searchKey: '',
          ruleId: ''
        },
        pageIndex: 1,
        pageSize: 10,
        totalCount: 0,
        dataList: [],
        groupList: [],
        dataListLoading: false,
        dataListSelections: [],
        addOrUpdateVisible: false,
        itemListBatchsettingVisible: false,
        importFieldListVisible: false
      }
    },
    components: {
      AddOrUpdate,ImportFieldList,ItemListBatchsetting
    },
    mounted() {
      this.dataForm.ruleId = this.dataSetId
      this.getDataList()
    },
    methods: {
      getRowsIndex (index) {
        return (this.pageIndex-1)* this.pageSize + index+1
      },
      // 每页数
      sizeChangeHandle (val) {
        this.pageSize = val
        this.pageIndex = 1
        this.getDataList()
      },
      // 当前页
      currentChangeHandle (val) {
        this.pageIndex = val
        this.getDataList()
      },
      // 多选
      selectionChangeHandle (val) {
        this.dataListSelections = val
      },
      // 新增 / 修改
      addOrUpdateHandle (id,ruleId, columnName) {
        this.addOrUpdateVisible = true
        this.$nextTick(() => {
          this.$refs.addOrUpdate.init(id,ruleId,columnName)
        })
      },
      // 新增 / 修改
      importFieldListHandle () {
        let ruleId=this.dataForm.ruleId
        if(!ruleId){
          this.$message.error('数据集无效')
          return
        }
        this.importFieldListVisible = true
        this.$nextTick(() => {
          this.$refs.importFieldList.init(ruleId)
        })
      },
      batchSetting(ruleId){
        if(!ruleId){
          this.$message.error('数据集无效')
          return
        }
        if(this.dataListSelections.length===0){
          this.$message.error('请选择字段')
          return
        }
        this.itemListBatchsettingVisible=true;
        this.$nextTick(() => {
          this.$refs.batchsettingDialog.init(ruleId,this.dataListSelections)
        })
      },
      initColumnData() {
        this.$http({
          url: this.$httpReq.adornUrl('/customform/columnmeta/generateColumnMeta?id='+this.dataForm.ruleId),
          method: 'get',
          baseURL: '',
        }).then(({data}) => {
          if (data && data.code === '1') {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        });
      },
      deleteCache(tableId) {
        this.$http({
          url: this.$httpReq.adornUrl('/customform/columnmeta/deleteCache?tableId='+tableId),
          method: 'get',
          baseURL: '',
        }).then(({data}) => {
          if (data && data.code === '1') {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500
            })
          } else {
            this.$message.error(data.msg)
          }
        });
      },
      // 获取数据列表
      getDataList() {
        this.dataListLoading = true
        this.$httpReq({
          url:'/customform/columnmeta/list',
          method: 'post',
            baseURL: process.env.VUE_APP_proxybaseurl + '',
          data: {
            filter:{
              tableId:this.dataForm.ruleId
            },
            page:this.pageIndex,
            rows:this.pageSize,
            'searchKey': this.dataForm.searchKey
          }
        }).then(({data}) => {
          if (data ) {
            this.dataList = data.rows
              this.$refs.dataTable.doLayout()
            this.totalCount = data.total
            this.pageIndex = data.pageIndex
          } else {
            this.dataList = []
            this.totalCount = 0
            this.pageIndex =1
          }
          this.dataListLoading = false
        })
      },

      // 删除
      deleteHandler (id) {
        this.$confirm(`确定要删除该数据?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$httpReq({
            url: '/customform/columnmeta/delete',
            method: 'post',
            baseURL: process.env.VUE_APP_proxybaseurl + '',
            data: {
              id:id
            }
          }).then(({data}) => {
            if (data && data.code === '1') {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.getDataList()
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }).catch(() => {})
      }
    }
  }
</script>
